// @ts-nocheck
/* eslint-disable */
/**
 * Bulldrop API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `:thumbsup:` - Thumbsup
 * * `:thumbsdown:` - Thumbsdown
 * * `:fire:` - Fire
 * * `:sparkler:` - Sparkler
 * * `:heart:` - Heart
 * * `:clown_face:` - Clown Face
 * * `:laughing:` - Laughing
 * * `:eggplant:` - Eggplant
 * @export
 */
export const ReactionEnum = {
    Thumbsup: ':thumbsup:',
    Thumbsdown: ':thumbsdown:',
    Fire: ':fire:',
    Sparkler: ':sparkler:',
    Heart: ':heart:',
    ClownFace: ':clown_face:',
    Laughing: ':laughing:',
    Eggplant: ':eggplant:'
} as const;
export type ReactionEnum = typeof ReactionEnum[keyof typeof ReactionEnum];


export function ReactionEnumFromJSON(json: any): ReactionEnum {
    return ReactionEnumFromJSONTyped(json, false);
}

export function ReactionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReactionEnum {
    return json as ReactionEnum;
}

export function ReactionEnumToJSON(value?: ReactionEnum | null): any {
    return value as any;
}

